import { DateTime } from 'luxon';
import { createOfferContractTypes, dateData, dateDataAdditional, isPublicHoliday } from "../../Common/commondata/commonData";
import setDayOfWeek from "./helpers/setDayOfWeek";
import { contractStoreHandle } from "../../ContractStore/state/actions";


const holidayCheck = ({startDate, MECDate, dateData, index, iterator, currentUrlId, forMEC, selectedRulesForDateTable, contractData}) => {
  const MAX_ITERATIONS = 60; // Prevent infinite recursion
  if (iterator > MAX_ITERATIONS) {
    console.error("Max recursion limit reached in holidayCheck");
    return { MEC: startDate, objectForDateTableList: {} };
  }

  let newDay = startDate;
  let dayObject = DateTime.fromFormat(newDay, "yyyy-MM-dd");
  const isHoliday = (new Set(isPublicHoliday.map((date) =>  DateTime.fromISO(date).toFormat("yyyy-MM-dd")))).has(newDay);
  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const dayOfWeek = daysOfWeek[dayObject.weekday - 1];
  const isWeekend = ((dayObject.weekday === 6) || (dayObject.weekday === 7)) ? true : false;

  if (selectedRulesForDateTable && Object.keys(selectedRulesForDateTable).length > 0) {
    // exclude holiday
    if (selectedRulesForDateTable?.excludeHolidays === true && isHoliday) {
      newDay = dayObject.plus({ days: 1 }).toFormat("yyyy-MM-dd");
      return holidayCheck({ startDate: newDay, MECDate, dateData, index, iterator: iterator + 1, currentUrlId, forMEC, selectedRulesForDateTable, contractData });
    }
    // Exclude weekends (Saturday = 6, Sunday = 0)
    if (selectedRulesForDateTable.excludeWeekends === true && isWeekend) {
      newDay = dayObject.plus({ days: 1 }).toFormat("yyyy-MM-dd");
      return holidayCheck({ startDate: newDay, MECDate, dateData, index, iterator: iterator + 1, currentUrlId, forMEC, selectedRulesForDateTable, contractData });
    }
    // Exclude specific weekdays
    if (Array.isArray(selectedRulesForDateTable?.excludeSpecificDay) && selectedRulesForDateTable.excludeSpecificDay?.includes(dayOfWeek)) {
      newDay = dayObject.plus({ days: 1 }).toFormat("yyyy-MM-dd");
      return holidayCheck({ startDate: newDay, MECDate, dateData, index, iterator: iterator + 1, currentUrlId, forMEC, selectedRulesForDateTable, contractData });
    }
  } else {
    if (isWeekend  || isHoliday) {
      newDay = dayObject.plus({ days: 1 }).toFormat("yyyy-MM-dd");
      return holidayCheck({startDate: newDay, MECDate, dateData, index, iterator: iterator + 1, currentUrlId, forMEC, contractData});
    } else {
      let objectForDateTableList={}
      if (!forMEC) {
        objectForDateTableList = {
          type: 'date',
          value: newDay
        };
      }
      return {
        objectForDateTableList,
        MEC: newDay,
      };
    }
  }
  // If no exclusions apply, return the calculated date
  const objectForDateTableList = forMEC ? {} : { type: "date", value: newDay };
  return { objectForDateTableList, MEC: newDay };
};

const autoFillDateLogic = ({currentUrlId, source, specificData, selectedRulesForDateTable, contractAuthKey, dispatch, templateDateTableData, contractData}) => {
  if (!selectedRulesForDateTable) {
    selectedRulesForDateTable = JSON.parse(localStorage.getItem(currentUrlId))?.selectedRulesForDateTable || null;
  }
  let calculationDate;
  if (source === "Initial") {
    calculationDate = DateTime.now().setZone(contractData?.timezone).plus({ days: 1 }).toFormat("yyyy-MM-dd");
    // CHECK IF TEMPLATE RELATIVE DATES PRESENT IN TD VERY FIRST TIME
    let filteredRelativeDateTableData = checkOCD({currentUrlId})
    if (Object.entries(filteredRelativeDateTableData).length > 0) {
      let OriginalContractDate = DateTime.now().toFormat('yyyy-MM-dd');
      Object.entries(filteredRelativeDateTableData).forEach(([key, valueObj]) => {
        templateDateTableData[key] = findAndReplaceDate({key, valueObj, OriginalContractDate, currentUrlId});
      });
      return;
    }
  } else {
    let OriginalContractDate = JSON.parse(localStorage.getItem(currentUrlId))?.OriginalContractDate;
    calculationDate = DateTime.fromISO(OriginalContractDate).plus({ days: 1 }).toFormat("yyyy-MM-dd");
  }
  const { MEC } = holidayCheck({startDate: calculationDate, MECDate: null, dateData: null, index: null, iterator: 0, currentUrlId: null, forMEC: true, selectedRulesForDateTable, contractData});
  const MECDate = DateTime.fromISO(MEC);
  // const dateTable = {};
  const ClosingDate = JSON.parse(localStorage.getItem(currentUrlId))?.ClosingDate ||"";
  const localDataUpdates = {};
  let valueObj = {};
  for (let index = 0; index < dateData.length; index++) {
    if (dateData[index].type === "date") {
      const diff = dateData[index].differnce;
      if (diff) {
        const getDigits = diff.split("-");
        const getDateforevent = Math.ceil((Number(getDigits[0]) + Number(getDigits[1])) / 2);
        const adjustedDays = (diff.indexOf("-") > 0) ? getDateforevent : Number(diff);
        const startDate = MECDate.plus({ days: adjustedDays }).toFormat("yyyy-MM-dd"); 
        const { objectForDateTableList } = features.holidayCheck({startDate, MECDate, dateData, index, iterator: 0, currentUrlId, forMEC: false, selectedRulesForDateTable, contractData});
        localDataUpdates[dateData[index].keyName] =dateData[index].keyName==="PossessionDate"? typeof ClosingDate ==="object" ? ClosingDate : {type:"date", value:ClosingDate} : objectForDateTableList;
        valueObj[dateData[index].keyName] = localDataUpdates[dateData[index].keyName];
        if (source === "ToggleCheckbox") {
          let dateInputElement = document.querySelectorAll("input[name='" + dateData[index].keyName + "']");
          dateInputElement.forEach((el) => {
            el.value = objectForDateTableList?.value;
          });
          specificData[dateData[index].keyName] =dateData[index].keyName==="PossessionDate"? typeof ClosingDate ==="object" ? ClosingDate : {type:"date", value:ClosingDate} : objectForDateTableList;
          setDayOfWeek({
            name: dateData[index].keyName,
            value:dateData[index].keyName==="PossessionDate"? (ClosingDate?.value || ClosingDate) : objectForDateTableList?.value,
          });
        }
      }
    } else {
      localDataUpdates[dateData[index].keyName] = dateData[index].time;
      valueObj[dateData[index].keyName] = localDataUpdates[dateData[index].keyName];
      if (source === "ToggleCheckbox") {
        let dateInputElement = document.querySelectorAll("input[name='" + dateData[index].keyName + "']");
        dateInputElement.forEach((el) => {
          el.value = dateData[index].time;
        });
        specificData[dateData[index].keyName] = dateData[index].time;
      }
    
    }
  }

  const localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};

  for (let index = 0; index < dateDataAdditional?.length; index++) {
    if (source === 'MODIFY_DATE_TABLE_RULE') {
      if (dateDataAdditional[index].type === "date" && dateDataAdditional[index].keyName === 'ClosingDate' && ClosingDate) {
        const { objectForDateTableList } = features.holidayCheck({startDate: ClosingDate, MECDate, dateData: dateDataAdditional, index, iterator: 0, currentUrlId, forMEC: false, selectedRulesForDateTable, contractData});
        localDataUpdates['ClosingDate'] = objectForDateTableList?.value; // Closing date is a string only not an object
        valueObj['ClosingDate'] = localDataUpdates['ClosingDate'];
      }
      if (dateDataAdditional[index].type === "date" && dateDataAdditional[index].keyName === 'PossessionDate' && (localData?.PossessionDate?.value || ClosingDate)) {
        let startDate = localData?.PossessionDate?.value || ClosingDate;
        const { objectForDateTableList } = features.holidayCheck({startDate, MECDate, dateData: dateDataAdditional, index, iterator: 0, currentUrlId, forMEC: false, selectedRulesForDateTable, contractData});
        localDataUpdates['PossessionDate'] = objectForDateTableList;
        valueObj['PossessionDate'] = objectForDateTableList;
      } else {
        if (dateDataAdditional[index].type === "date" && localData[dateDataAdditional[index].keyName]?.value) {
          let startDate = localData[dateDataAdditional[index].keyName]?.value;
          const { objectForDateTableList } = features.holidayCheck({startDate, MECDate, dateData: dateDataAdditional, index, iterator: 0, currentUrlId, forMEC: false, selectedRulesForDateTable, contractData});
          localDataUpdates[dateDataAdditional[index].keyName] = objectForDateTableList;
          valueObj[dateDataAdditional[index].keyName] = objectForDateTableList;
        }
      }
    }
  }

  Object.assign(localData, localDataUpdates); // modify the existing object in-place and saves memory
  localStorage.setItem(currentUrlId, JSON.stringify(localData));
  const persistKey = JSON.parse(localStorage.getItem(currentUrlId)) || {};
  localStorage.setItem(currentUrlId, JSON.stringify(persistKey || {}));
  if (source === 'MODIFY_DATE_TABLE_RULE') {
    dispatch(contractStoreHandle.autoSaveContract({currentUrlId, contractAuthKey, valueObj:{...specificData, ...valueObj, selectedRulesForDateTable}}));
  }
};


const findAndReplaceDate = ({key, valueObj, OriginalContractDate, currentUrlId, contractData}) => {
  if (valueObj.type === 'mec') {
    return valueObj;
  }
  if (valueObj.type === 'OCD' && OriginalContractDate) {
    const baseDate = DateTime.fromFormat(OriginalContractDate, "yyyy-MM-dd");
    let calculatedDate;
    if (valueObj.value > 0 || valueObj.relation.includes('after')) {
      calculatedDate = baseDate.plus({ days: valueObj.value }); // Add days
    } else if (valueObj.value < 0 || valueObj.relation.includes('before')) {
      calculatedDate = baseDate.minus({ days: Math.abs(valueObj.value) });// Subtract days
    } else {
      calculatedDate = baseDate; // Same as contract date
    }
    valueObj.value = calculatedDate.toFormat("yyyy-MM-dd");

    let selectedRulesForDateTable = JSON.parse(localStorage.getItem(currentUrlId))?.selectedRulesForDateTable || null;
    if (calculatedDate) {
      calculatedDate = calculatedDate.toFormat("yyyy-MM-dd");
      const { objectForDateTableList } = features.holidayCheck({startDate: calculatedDate, MECDate: null, dateData: null, index: null, iterator: 0, currentUrlId, forMEC: false, selectedRulesForDateTable, contractData});
      if (objectForDateTableList?.value) {
        valueObj.value = objectForDateTableList?.value;
      }
    }
  }

  return valueObj = {
    value: valueObj.value,
    type: 'date',
  };
};

const convertDateFromDateTemplate = ({ templateTd, currentLocalData, rootDocData, currentUrlId, contractData }) => {
  let OriginalContractDate = null;
  if (createOfferContractTypes.includes(rootDocData?.contractType)) {
    OriginalContractDate = currentLocalData['OriginalContractDate'];
  }
  
  const dateTableObject = Object.entries(templateTd).reduce((acc, [key, value]) => {
    if (typeof value === 'object' && (value.relation || value.type === 'mec')) {
      acc[key] = value;
    }
    return acc;
  }, {});

  if (OriginalContractDate && Object.entries(dateTableObject).length > 0) {
    Object.entries(dateTableObject).forEach(([key, valueObj]) => {
      dateTableObject[key] = findAndReplaceDate({key, valueObj, OriginalContractDate, currentUrlId, contractData});
    });
  }

  return dateTableObject || {};
};


let checkOCD = ({ currentUrlId }) => {
  let transactionData = JSON.parse(localStorage.getItem(currentUrlId));
  if (!transactionData) {
    return {}; // Return empty object if transactionData is null or undefined
  }

  let filteredRelativeDateTableData = Object.entries(transactionData)
    .filter(([key, value]) => typeof value === 'object' && value !== null && value.type === 'OCD')
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

  return filteredRelativeDateTableData;
};

export const features = {
  holidayCheck,
  autoFillDateLogic,
  convertDateFromDateTemplate,
};
